import { useSelector } from "react-redux";
import ResourceCharges from "../../Charges/components/ResourceCharges";
import ResourceDetails from "../../Details/components/ResourceDetails";
import ResourceFuelAndLubricants from "../../FulesAndLubricants/components/ResourceFuelAndLubricants";
import ResourceRegistrationAndTachograph from "../../RegistrationAndTachograph/components/ResourceRegistrationAndTachograph";
import ResourceServiceAndRepair from "../../ServiceAndRepair/components/ResourceServiceAndRepair";
import { selectResource } from "../main.slice";
import { useEmployeeOptions } from "Dashboard/scenes/HumanResources/hooks/EmployeeOptions";
import { useProjectOptions } from "Dashboard/hooks/ProjectsOptions";

const BottomSection = () => {
  const resourceItem = useSelector(selectResource);
  const employeeOptions = useEmployeeOptions();
  const projectOptions = useProjectOptions({ showHiddenInDropDowns: false });

  return (
    <section>
      <div className="resources-bottom-content">

        {resourceItem ?
          <ResourceDetails resourceId={resourceItem?.resourceId} />
          : ""}

        {resourceItem ?
          <ResourceCharges resourceId={resourceItem?.resourceId} employeeOptions={employeeOptions} projectOptions={projectOptions} />
          : ""}

        {resourceItem?.category.name === 'VEHICLE'
          || resourceItem?.category.name === 'MECHANIZATION'
          || resourceItem?.category.name === 'MANUAL_MACHINE'
          || resourceItem?.category.name === 'POWER_TOOL'
          || resourceItem?.category.name === 'HAND_TOOL'
          || resourceItem?.category.name === 'ACCESSORY'
          || resourceItem?.category.name === 'IT_EQUIPMENT'
          || resourceItem?.category.name === 'OTHER' ?
          <ResourceFuelAndLubricants resourceId={resourceItem?.resourceId} /> : ""}
        <div></div>

        {resourceItem?.category.name === 'VEHICLE'
          || resourceItem?.category.name === 'MECHANIZATION'
          || resourceItem?.category.name === 'MANUAL_MACHINE'
          || resourceItem?.category.name === 'POWER_TOOL'
          || resourceItem?.category.name === 'HAND_TOOL'
          || resourceItem?.category.name === 'ACCESSORY'
          || resourceItem?.category.name === 'IT_EQUIPMENT'
          || resourceItem?.category.name === 'OTHER' ?
          <ResourceServiceAndRepair resourceId={resourceItem?.resourceId} /> : ""}

        {resourceItem?.category.name === 'VEHICLE'
          || resourceItem?.category.name === 'MECHANIZATION' ?
          <ResourceRegistrationAndTachograph
            resourceId={resourceItem?.resourceId}
          /> : ""}
      </div>
    </section>
  );
};

export default BottomSection;
